import type { IUrlVars } from '../vars/url';

const devDomain = 'dev.yocoolmate.com';

export function buildDevUrls(): IUrlVars {
  const webBase = `https://${devDomain}`;
  const telegramUrl = `https://tg.${devDomain}`;
  return {
    identityUrl: `https://identity.${devDomain}`,
    apiUrl: `https://api.${devDomain}`,
    webUrl: webBase,
    loginUrl: `${webBase}/login`,
    cookieDomain: `.${devDomain}`,
    passkeyDomain: devDomain,
    allowedOrigins: [webBase, telegramUrl],
    catalogUrl: `https://catalog.${devDomain}`,
    vaultUrl: 'https://media-vault.yocoolmate.com',
    vaultApiKey: 'vk-prod-2b8d6f4a1c3e7950',
    telegramUrl,
  };
}
